import { Component, OnInit } from '@angular/core';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-request-extension',
  templateUrl: './request-extension.component.html',
  styleUrls: ['./request-extension.component.css']
})
export class RequestExtensionComponent implements OnInit {
  tableData;
  activesidetab;
  minDate: any;
  maxDate: any;
  yearDropDownList : [];
  dateformat = {value: 'yyyyMMdd'}
  dontshowotherdropdowns : boolean = true;
  shownodata : boolean = false;
  windowdata :any;
  userdetails :any;
  activeSpinner : boolean = false;
  requestextentionparams : object = {'assessmentyear' : '','month':'','startdate' : '','enddate' : '','extensiondate':'','reasonforextension':''};
  validation: boolean[] = new Array(3).fill(true);
  approveparams : object = {assessmentyear : '',month:''}
  state_nodal_officer: string;
  districtdropdownlist: any;
  dist_nodal_officer: string;
  setYear;

  monthList = {
    '06': 'June',
     '07':'July',
     '08':'August',
     '09':'September',
    '10': 'October',
     '11':'November',
     '12': 'December',
     '01':'January',
    '02': 'February',
     '03':'March',
     '04': 'April',
     '05':'May',
  };

  monthlist:{key: string, value:string}[] = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
    
    ];
  constructor(private submitdataservice :SubmitdataService,
    private constants : ConstantsModule,
    private logsrv : AuthloginService,
    private utils : UtilsModule,
    private toastr : ToastrService) { }

  ngOnInit() {
    this.submitdataservice.getStatusOfToken();
    this.fetchAssesmentYear()
    this.initonload() 
    this.setCurrentMonthFullName();
    // this.monthlist.sort((a, b) => a.value.localeCompare(b.value));    
  }
  initonload(){
    // this.requestextentionparams;
    // console.log("llll",this.submitdataservice.getassesmentYear()[this.submitdataservice.getassesmentYear().length-1])
    // this.yearDropDownList = this.submitdataservice.getassesmentYear();
    this.districtdropdownlist = this.submitdataservice.getAssesmentYearDistrict();
    this.state_nodal_officer = this.constants.USER_TYPES["STATE_NODAL_OFFICER"];
    this.dist_nodal_officer  = this.constants.USER_TYPES['DISTRICT_NODAL_OFFICER'];

    this.userdetails = this.logsrv.checkloginstatus();
    // console.log('userdetails',this.userdetails);
    this.requestextentionparams['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
    this.navtabclick('request');
    // this.getWindowStatus();
  }
  public navtabclick(type){
    if(type == this.activesidetab)
     return
    this.activesidetab = type;
    if(this.activesidetab == 'request')
      this.initonload();
    else {
      this.approveparams['assessmentyear'] = this.yearDropDownList[this.yearDropDownList.length-1]
      this.getraiserequesthistory();
    }
    }
    fetchAssesmentYear(){
      let currentYear = new Date().getFullYear();
      let currentmonth = new Date().getMonth();
      let dropDownYear;
      if(currentmonth <3){
        dropDownYear = (currentYear - 1) + '-'+ currentYear;
      } else{
        dropDownYear = currentYear + '-'+ (currentYear + 1);
      }
      // let dropDownYear = currentyear + '-' + (currentyear+1);
      this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];      
    })
      this.requestextentionparams['assessmentyear'] = dropDownYear;
    }
    
    setCurrentMonthFullName() {
      let currentmonth = new Date().getMonth()
      let currentmonthObj;
      this.monthlist.forEach(monthObj => {
        if (parseInt(monthObj['key']) == currentmonth + 1) {
          currentmonthObj = monthObj;
        }
      });
      this.requestextentionparams['month'] = currentmonthObj['key'];
      this.approveparams['month']=currentmonthObj['key'];
    }

    getraiserequesthistory(){
      this.activeSpinner = true;
      this.tableData = [];
      this.approveparams['lu'] = this.userdetails['loggedUserData']['userProfile']['associatedlocationsDetails'][0]['entityUUID']
      let postdata = {
        "lu": this.approveparams['lu'],
        "ay": this.requestextentionparams['assessmentyear'],
        "view": this.constants.VIEWS['admin'],
        "cType": this.state_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['DISTRICT'] : this.constants.LOCATION_CONSTANT['DISTRICT'],
        "subTp":this.approveparams['month']
      }
      this.submitdataservice.getraiserequesthistory(postdata).subscribe(data =>{
        this.tableData = data;
        if(this.tableData.length == 0){
          this.shownodata = true;
        } else 
          this.shownodata = false;
      this.activeSpinner = false;
      });
    }
    approveyearchanged(){
      //this.getraiserequesthistory();
    }
    async getWindowStatus(){
      let options = {
        "childlist":  [this.requestextentionparams['lu']],
        // "yearlist": this.submitdataservice.getassesmentYear(),
        "yearlist":this.yearDropDownList,
        "monthlist":this.submitdataservice.getMonthList(),
        "view": this.constants.VIEWS['admin'],
        "cType": this.state_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['DISTRICT'],
        "pEUUID" :this.dist_nodal_officer == this.userdetails['roles'][0] ? this.userdetails['loggedUserData']['userProfile']['stateUUID']: this.userdetails['loggedUserData']['userProfile']['locationId']
      }
      // console.log('options',options);
      this.windowdata = await this.submitdataservice.getWindowStatus(options);
      let year=this.requestextentionparams['assessmentyear']+"#"+this.requestextentionparams['month'];
      // console.log("window data",this.windowdata,"assessment year",this.requestextentionparams['assessmentyear'],"lu",this.requestextentionparams['lu']);
      this.dontshowotherdropdowns = this.submitdataservice.checkwindow(this.windowdata,year,this.requestextentionparams['lu'],true);
      // console.log('dontshow',this.dontshowotherdropdowns);
      if(!this.dontshowotherdropdowns){
        this.setstartenddate();
      }
    }
    getYearAndMonth(year,index){
      let arr=year.split("#");
        arr[1]=this.monthList[arr[1]];
        return (arr && (arr.length-1>=index) && arr[index])?arr[index]:"-"
    }
    selectOption(month){
       if(this.activesidetab != 'request'){
         this.approveparams['month']=month;
         //this.getraiserequesthistory();

       }
      
      this.requestextentionparams['month'] = month
      console.log("requested month",this.requestextentionparams['month'])
      let year=this.requestextentionparams['assessmentyear']+"#"+this.requestextentionparams['month'];
      console.log("appended value",year)
      this.yearchanged(year);
      }
      
    setstartenddate(){
      // console.log(new Date(this.windowdata[this.requestextentionparams['assessmentyear']][this.requestextentionparams['lu']]['sdate']))
      let year= this.requestextentionparams['assessmentyear']+"#"+this.requestextentionparams['month'];
      this.requestextentionparams['startdate'] = this.utils.getDateInFormatFromModelDate((this.windowdata[year][this.requestextentionparams['lu']]['sdate']).toString(),"dd-MM-yyyy")
      this.requestextentionparams['enddate'] = this.utils.getDateInFormatFromModelDate((this.windowdata[year][this.requestextentionparams['lu']]['edate']).toString(),"dd-MM-yyyy")
      this.minDate = new Date(this.utils.getDateInFormatFromModelDate((this.windowdata[year][this.requestextentionparams['lu']]['edate']).toString(),"yyyy/MM/dd"))
    console.log("request extension params",this.requestextentionparams)
    }
    datepickermodel(value){
      console.log(value);
      this.requestextentionparams['extensiondate'] = value;
    }

    onYearChange(year){
     this.setYear=year;
     console.log("year changed",year)


    }
    
    yearchanged(year){
      this.dontshowotherdropdowns = this.submitdataservice.checkwindow(this.windowdata,year,this.requestextentionparams['lu'],true);
      // console.log('dontshowdropdown',this.dontshowotherdropdowns);
      // if(!this.dontshowotherdropdowns && year)
      console.log("entered if")
        // this.setstartenddate();
    }
    submit(){
      console.log(this.requestextentionparams['extensiondate'])
      if(this.basicvalidation()){
      let postdata = {
        "cType" : this.state_nodal_officer == this.userdetails['roles'][0] ? this.constants.LOCATION_CONSTANT['STATE'] : this.constants.LOCATION_CONSTANT['DISTRICT'],
        "reason" : this.requestextentionparams['reasonforextension'],
        "view" : this.constants.VIEWS['admin'],
        "ay" : this.requestextentionparams['assessmentyear'],
        "extensiondate" : parseInt(this.utils.getDateInFormatFromDateObject(this.requestextentionparams['extensiondate'],"yyyyMMdd")),
        "lu" :this.requestextentionparams['lu'],
        "subTp":this.requestextentionparams['month'],
      }
      this.submitdataservice.raisewindowrequest(postdata).subscribe(data =>{
        if(data.status){
          this.toastr.success(data['msg']);
          // this.initonload()
        } else {
          this.toastr.error("Error while submitting request");
        }
      });
    }
   }
    basicvalidation(){
      this.validation[0] = this.utils.checkfields(this.requestextentionparams['extensiondate']);
      this.validation[1] = this.utils.checkfields(this.requestextentionparams['reasonforextension']);
      this.validation[2]=this.utils.checkfields(this.requestextentionparams['month']);
      return this.validation[0] && this.validation[1] && this.validation[2];
    }
  }

